import { MOCK_DATA_INVOICES, MOCK_USER_SUBSCRIPTION } from "./MOCK_DATA";

export const getUserSubscriptionPlan = (useMock?: boolean) => {
  if (useMock) {
    return Promise.resolve({
      json: () => Promise.resolve(MOCK_USER_SUBSCRIPTION),
    });
  }
  return fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/subscriptions/getSubscriptionPlan`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const reactivateSubscription = () =>
  fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/subscriptions/reactivateSubscription`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

export const cancelSubscription = () =>
  fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/subscriptions/cancelSubscription`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

export const getListOfInvoices = (useMockData = false) => {
  if (useMockData) {
    return Promise.resolve({
      json: () => Promise.resolve(MOCK_DATA_INVOICES),
    });
  }
  return fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/subscriptions/listInvoices`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const getBOTBPassUrl = () =>
  fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/StripeSubscriptionServerSide/GetBotbPassUrl`);

export const getSubscriptionLobbyContent = async (
  abortController: AbortController
): Promise<SubscriptionLobbyContent> => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/SubscriberCompetition/GetsubscriptionLobbyContent`,
    {
      signal: abortController.signal,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.json();
};
